module.exports = __webpack_public_path__ + "static/media/bookIcon.89c889ba.svg";